// extracted by mini-css-extract-plugin
module.exports = {"navBar":"Navbar_navBar__3dPS2","dummy":"Navbar_dummy__1iIfh","link":"Navbar_link__1olL_","active":"Navbar_active__p0W_S"};